import { actions, mutations } from "@/constants/state";
import { getRoosterForecast } from "@/services/rooster-forecast-service";

export default {
  [actions.ROOSTER_FORECAST_FETCH_ACTION]: async (
    { commit },
    { from, until }
  ) => {
    const { data } = await getRoosterForecast(from, until);
    commit(mutations.ROOSTER_FORECAST_FETCH_MUTATION, data);
  },
};
